import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/auth/login.vue'
import index from '../views/index.vue'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '*',
    redirect: "/home"
  },
  {
    path: '/enrolled',
    component: resolve => require(['../views/auth/enrolled'], resolve)
  },
  {
    path: '/zpdj',
    component: resolve => require(['../views/h5/zpdj'], resolve)
  },
  {
    path: '/zpqs/:id',
    component: resolve => require(['../views/h5/zpqs'], resolve)
  },
  {
    path: '/qyxjh/:id',
    component: resolve => require(['../views/h5/qyxjh'], resolve)
  },
  {
    path: '/h5xjh/:id',
    component: resolve => require(['../views/h5/h5xjh'], resolve)
  },
  {
    path: '/h5_job_manage',
    component: resolve => require(['../views/h5/h5_job_manage'], resolve)
  },
  {
    path: '/index',
    name: 'index',
    component: index,
    children: [
      {
        path: '/enterInfo',
        component: resolve => require(['../views/pages/enterInfo'], resolve)
      },
      {
        path: '/home',
        component: resolve => require(['../views/pages/home'], resolve)
      },
      {
        path: '/tjjl',
        component: resolve => require(['../views/pages/tjjl'], resolve)
      },
      {
        path: '/sddjl',
        component: resolve => require(['../views/pages/sddjl'], resolve)
      },
      {
        path: '/yqjl',
        component: resolve => require(['../views/pages/yqjl'], resolve)
      },
      {
        path: '/xxzph',
        component: resolve => require(['../views/pages/xxzph'], resolve)
      }, {
        path: '/qyxjh',
        component: resolve => require(['../views/pages/qyxjh'], resolve)
      },
      {
        path: '/sx_stus',
        component: resolve => require(['../views/pages/sxStus'], resolve)
      },
      {
        path: '/sxqyResearcreport',
        component: resolve => require(['../views/pages/sxqyResearcreport'], resolve)
      }, 
    ]
  }
]

const router = new VueRouter({
  routes
})
export default router
